import React, {createContext, useReducer} from 'react'

export const SET_INSPECTION_POINTS_LIST = 'SET_INSPECTION_POINTS_LIST'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case SET_INSPECTION_POINTS_LIST:
      return { ...data, inspection_points_list: payload.data }
    default:
      return data
  }
}

const initialState = {
  inspection_points_list: [],
}

const InspectionPointsStore = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <InspectionPointsContext.Provider value={[state, dispatch]}>
      {children}
    </InspectionPointsContext.Provider>
  )
}

export const InspectionPointsContext = createContext(initialState)
export default InspectionPointsStore
